import { render, staticRenderFns } from "./ProductStockList.vue?vue&type=template&id=79491c48&scoped=true&"
import script from "./ProductStockList.vue?vue&type=script&lang=js&"
export * from "./ProductStockList.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockList.vue?vue&type=style&index=0&id=79491c48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79491c48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79491c48')) {
      api.createRecord('79491c48', component.options)
    } else {
      api.reload('79491c48', component.options)
    }
    module.hot.accept("./ProductStockList.vue?vue&type=template&id=79491c48&scoped=true&", function () {
      api.rerender('79491c48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/basic/report/ProductStockList.vue"
export default component.exports